declare global {
    interface Window {
        _hsq: [string, {}?][];

        HubSpotConversations: {
            widget: any;
        };
    }
}

window._hsq = window._hsq || [];

export function identify(email: string, otherDetails = {}) {
    window._hsq.push(['identify', { email, ...otherDetails }]);
}

export function trackPageView() {
    window._hsq.push(['trackPageView']);
}

export function trackEvent(id: number, value: any) {
    window._hsq.push(['trackEvent', value === void null ? { id, value } : { id }]);
}

export function setPath(path: string) {
    window._hsq.push(['setPath', path]);
}

export function removeChatWidget() {
    window.HubSpotConversations?.widget?.remove();
}
